import React, { useRef } from "react";
import Box from "@mui/material/Box";
import { useStyles } from "./staticHeadlineStyles";
import { constants } from "../../constants";
import staticHeadlineLines from "../../assets/images/static-headline-lines.svg";
import useStaticHeadlineAnimations from "../../hooks/animations/useStaticHeadlineAnimations";
import { IStaticHeadline } from "./IStaticHeadline";
import clsx from "clsx";
const StaticHeadline = ({
    variant = "static-headline",
    headline,
    subHeadline,
}: IStaticHeadline) => {
    const backgroundImage = staticHeadlineLines;
    const { classes } = useStyles({ backgroundImage });
    const root = useRef(null);
    useStaticHeadlineAnimations(root);

    return (
        <Box
            data-name="StaticHeadline"
            ref={root}
            className={clsx([classes.root, variant])}
        >
            <Box className={classes.container}>
                <span id="heading" className={classes.heading}>
                    {headline ?? constants.copy.staticHeadline.heading}
                </span>
                <span id="message" className={classes.message}>
                    {subHeadline ?? constants.copy.staticHeadline.message}
                </span>
            </Box>
        </Box>
    );
};

export default StaticHeadline;
